"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RelatedArticlesList = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RelatedArticlesCard = _interopRequireDefault(require("../RelatedArticlesCard"));
var _styles = require("./styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// Explicit export is unwrapped with 'styled'

var RelatedArticlesList = function RelatedArticlesList(_ref) {
  var relatedArticles = _ref.relatedArticles,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_styles.BaseRelatedArticlesList, {
    className: className,
    "data-testid": "related-articles"
  }, relatedArticles.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_RelatedArticlesCard.default, {
      key: item.title,
      item: item,
      testId: "related-articles:card-".concat(index)
    });
  }));
};
exports.RelatedArticlesList = RelatedArticlesList;
var _default = (0, _styledComponents.default)(RelatedArticlesList).withConfig({
  displayName: "RelatedArticlesList",
  componentId: "sc-1t540b5-0"
})([""]);
exports.default = _default;